import { Stack } from '@mui/material';
import { Panel } from '@xyflow/react';

import { Text, type api, isDefined } from 'common';

import { FlowDefinitionStateTag } from '../../Definitions/common/StateTag';

export interface ReactFlowVersionOverlayProps {
  version: number;
  state?: api.FlowDefinition.FlowDefinition['state'];
  left?: 16 | 32;
  top?: 8 | 16 | 64;
}

export function ReactFlowVersionOverlay(props: ReactFlowVersionOverlayProps) {
  const { version, state, left = 32, top = 16 } = props;
  return (
    <Panel
      style={{
        marginTop: top,
        marginLeft: left,
      }}
    >
      <Stack direction="row" gap={0.5} alignItems="center">
        <Text variant="heading6" bold>
          v{version}
        </Text>
        {isDefined(state) && <FlowDefinitionStateTag state={state} />}
      </Stack>
    </Panel>
  );
}
